module.exports = __webpack_public_path__ + "img/een van de oudste golfbanen.2fae4aa6.jpg";